export default __webpack_public_path__ + "static/media/winning.c36bb712.mp3";